import kinetikApi from './kinetikAPI';

export default {
  getMembers: (orgId, options) =>
    kinetikApi
      .get(`/${orgId}/patients`, {
        ...options,
        serviceName: 'patient',
      })
      .then((res) => res.data),
  searchMembers: (orgId, options) =>
    kinetikApi
      .get(`/${orgId}/patients/search`, {
        ...options,
        serviceName: 'patient',
      })
      .then((res) => res.data),
  createMembers: (orgId, body) =>
    kinetikApi
      .post(`/${orgId}/patients`, body, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
  getReimbursableDriverProfiles: (orgId, options) =>
    kinetikApi
      .get(`/${orgId}/reimbursable-driver-profiles`, {
        ...options,
        serviceName: 'patient',
      })
      .then((res) => res.data),
  addReimbursableDriver: (orgId, body) =>
    kinetikApi
      .post(`/${orgId}/reimbursable-driver-profiles`, body, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
  updateReimbursableDriver: (orgId, driverUuid, body) =>
    kinetikApi
      .patch(`/${orgId}/reimbursable-driver-profiles/d/${driverUuid}`, body, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
  deleteReimbursableDriver: (orgId, driverUuid) =>
    kinetikApi
      .delete(`/${orgId}/reimbursable-driver-profiles/d/${driverUuid}`, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
  updateMember: (body, uuid, orgId) =>
    kinetikApi
      .patch(`${orgId}/patients/p/${uuid}`, body, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
  getNotes: (orgId, memberUuid, options) =>
    kinetikApi.get(`${orgId}/patient-notes/patient/${memberUuid}`, {
      ...options,
      serviceName: 'patient',
    }),
  createNotes: (orgId, memberUuid, body) =>
    kinetikApi
      .post(`${orgId}/patient-notes/patient/${memberUuid}`, body, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
  updateNote: (orgId, noteUuid, body) =>
    kinetikApi
      .patch(`${orgId}/patient-notes/n/${noteUuid}`, body, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
  deleteNote: (orgId, noteUuid) =>
    kinetikApi
      .delete(`${orgId}/patient-notes/n/${noteUuid}`, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
  bulkUpdateMember: (body, orgId, options) =>
    kinetikApi
      .patch(`${orgId}/patients/bulk`, body, {
        ...options,
        serviceName: 'patient',
      })
      .then((res) => res.data),
  getEvents: (uuid, orgId, options) =>
    kinetikApi
      .get(`${orgId}/patients/p/${uuid}/events`, {
        ...options,
        serviceName: 'patient',
      })
      .then((res) => res.data),
  uploadEdi: (orgId, body) =>
    kinetikApi
      .post(`/${orgId}/patients/edi-834`, body, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        serviceName: 'patient',
      })
      .then((res) => res.data),
  uploadMemberDocument: (orgId, memberId, body) =>
    kinetikApi
      .post(`/${orgId}/patients/p/${memberId}/documents`, body, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        serviceName: 'patient',
      })
      .then((res) => res.data),
  getMemberDocuments: (orgId, memberId, options) =>
    kinetikApi
      .get(`/${orgId}/patients/p/${memberId}/documents`, {
        ...options,
        serviceName: 'patient',
      })
      .then((res) => res.data),
  deleteMemberDocument: (orgId, memberId, documentId) =>
    kinetikApi
      .delete(`/${orgId}/patients/p/${memberId}/documents/d/${documentId}`, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
  updateMemberDocument: (orgId, memberId, documentId, body) =>
    kinetikApi
      .patch(
        `/${orgId}/patients/p/${memberId}/documents/d/${documentId}`,
        body,
        {
          serviceName: 'patient',
        },
      )
      .then((res) => res.data),
  bulkUpdateMemberDocuments: (body, orgId, memberId) =>
    kinetikApi
      .patch(`/${orgId}/patients/p/${memberId}/documents`, body, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
  downloadMemberDocument: (orgId, memberId, documentId, options) =>
    kinetikApi
      .get(
        `/${orgId}/patients/p/${memberId}/documents/d/${documentId}/download`,
        {
          ...options,
          serviceName: 'patient',
        },
      )
      .then((res) => res.data),
  createEnrollment: (orgId, memberId, body) =>
    kinetikApi
      .post(`/${orgId}/patients/p/${memberId}/enrollments`, body, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
  updateEnrollment: (orgId, memberId, enrollmentId, body) =>
    kinetikApi
      .patch(
        `/${orgId}/patients/p/${memberId}/enrollments/e/${enrollmentId}`,
        body,
        {
          serviceName: 'patient',
        },
      )
      .then((res) => res.data),
  deleteEnrollment: (orgId, memberId, enrollmentId) =>
    kinetikApi
      .delete(
        `/${orgId}/patients/p/${memberId}/enrollments/e/${enrollmentId}`,
        {
          serviceName: 'patient',
        },
      )
      .then((res) => res.data),
  getCoverage: (orgId, memberId, options) =>
    kinetikApi
      .get(`/${orgId}/patients/p/${memberId}/coverage`, {
        ...options,
        serviceName: 'patient',
      })
      .then((res) => res.data),
  updateMemberLabels: (orgId, memberUuid, labels) =>
    kinetikApi
      .patch(`${orgId}/patients/p/${memberUuid}/labels`, labels, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
  updateMemberNoteLabels: (orgId, noteUuid, labels) =>
    kinetikApi
      .patch(`${orgId}/patient-notes/n/${noteUuid}/labels`, labels, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
  updateMemberDocumentLabels: (orgId, patientUuid, documentUuid, labels) =>
    kinetikApi
      .patch(
        `${orgId}/patients/p/${patientUuid}/documents/d/${documentUuid}/labels`,
        labels,
        {
          serviceName: 'patient',
        },
      )
      .then((res) => res.data),
  addBlockedTransportationProvider: (body, uuid, orgId) =>
    kinetikApi
      .post(`${orgId}/patients/p/${uuid}/blocked-providers/add`, body, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
  removeBlockedTransportationProvider: (body, uuid, orgId) =>
    kinetikApi
      .patch(`${orgId}/patients/p/${uuid}/blocked-providers/remove`, body, {
        serviceName: 'patient',
      })
      .then((res) => res.data),
};
